const SLUGS = {
    DEEP_LINKS: 'deep-links',
    LIST_PAGE: 'list-page',
    SAVED_LIST: 'saved-list',
    SEARCH_PAGE: 'search-page',
};

export default SLUGS;
